export class SpeechPlayer {
  constructor(modelRef, isForRecording = false) {
    this.DELAY_SECOND = 0.5;
    this.VOLUME_THRESHOLD = 20;
    this.isForRecording = false;
    this.modelRef = modelRef;
    this.mouth = new MouthMovement(this.modelRef);
    this.audioArray = [];
    this.audioContext = new AudioContext();
    this.audioDestination = null;
    this.analyser = this.audioContext.createAnalyser();
    this.bufferLength = this.analyser.frequencyBinCount;
    this.dataArray = new Uint8Array(this.bufferLength);
    this.playSource = null;
    this.dummySource = null;
    this.intervalId = null;
    this.pausedTime = 0;
  }

  async preloadFromURL(audioID, audioFilePath) {
    const response = await fetch(audioFilePath);
    const soundBuffer = await response.arrayBuffer();
    return this.preloadFromBuffer(audioID, soundBuffer);
  }

  async preloadFromBuffer(audioID, soundBuffer) {
    //Copy Buffer to avoid issue
    let copyBuffer = this.copyArrayBuffer(soundBuffer);

    //Decode buffer to analyze
    const playBuffer = await this.audioContext.decodeAudioData(soundBuffer);
    const dummyBuffer = await this.audioContext.decodeAudioData(copyBuffer);

    //Add to array
    this.audioArray.push({
      audioID: audioID,
      playBuffer: playBuffer,
      dummyBuffer: dummyBuffer,
    });

    //Return with duration (mili secconds)
    return playBuffer.duration * 1000;
  }

  copyArrayBuffer(sourceBuffer) {
    const copy = new ArrayBuffer(sourceBuffer.byteLength);
    new Uint8Array(copy).set(new Uint8Array(sourceBuffer));
    return copy;
  }

  getMediaStream() {
    if (this.audioDestination != null) {
      return this.audioDestination.stream;
    } else {
      alert('Set isRecording = true when it is initialized');
      return null;
    }
  }

  async play(audioID) {
    if (this.playSource) {
      this.stopAll();
    }

    let bufferData;
    let dummyBufferData;
    for (let obj of this.audioArray) {
      if (obj.audioID === audioID) {
        // audio = obj['audio'];
        bufferData = obj['playBuffer'];
        dummyBufferData = obj['dummyBuffer'];
        break;
      }
    }

    if (bufferData == null) return;

    // Set For Play Audio
    this.playSource = this.audioContext.createBufferSource();
    this.playSource.buffer = bufferData;

    // For Recoding to get media stream
    if (this.isForRecording) {
      this.audioDestination = this.audioContext.createMediaStreamDestination();
      this.playSource.connect(this.audioDestination);
    } else {
      this.playSource.connect(this.audioContext.destination);
    }

    // Set for Dummy (Mute)
    this.dummySource = this.audioContext.createBufferSource();
    this.dummySource.buffer = dummyBufferData;
    this.dummySource.connect(this.analyser); // Connect only to analyser, not to destination, so no sound will be played

    // Moving mouth
    this.mouth.startPlaying();

    // Start both sources
    this.playSource.start(0); // Start from the beginning
    this.dummySource.start(0, 500); // Start from 500ms (or whatever DELAY_SECOND is set to)

    this.dataArray = new Uint8Array(this.analyser.frequencyBinCount);
    if (this.intervalId == null) {
      this.intervalId = setInterval(() => this.calculateVolume(), 50);
    }

    // this.playSource.onended = () => {
    //   //this.mouth.setStatus('stop');
    //   //clearInterval(this.intervalId);
    // };
  }

  stopAll() {
    if (this.playSource) {
      this.playSource.stop();
      this.playSource = null;
    }
    if (this.dummySource) {
      this.dummySource.stop();
      this.dummySource = null;
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.pausedTime = 0;

    //Stop Mouth Movement
    this.mouth.stopPlaying();
  }

  pause() {
    if (this.playSource) {
      this.pausedTime = this.audioContext.currentTime; // 現在の再生時間を保存
      this.playSource.stop(); // 再生を停止
      this.playSource = null; // ソースをクリア
    }
    if (this.dummySource) {
      this.dummySource.stop();
      this.dummySource = null;
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  calculateVolume() {
    this.analyser.getByteFrequencyData(this.dataArray);

    let sum = 0;
    for (const amplitude of this.dataArray) {
      sum += amplitude * amplitude;
    }

    const volume = Math.sqrt(sum / this.dataArray.length);

    if (volume > this.VOLUME_THRESHOLD) {
      this.mouth.setStatus('playing');
    } else {
      this.mouth.setStatus('stop');
    }
  }

  /*
  async analyzeSilence(audioID) {
    let bufferData;
    for (let obj of this.audioArray) {
      if (obj.audioID === audioID) {
        bufferData = obj['buffer'];
        break;
      }
    }

    if (bufferData == null) return [];

    const threshold = 0.02; // 閾値を0.02に設定
    const channelData = bufferData.getChannelData(0); // モノラル音声を想定
    const sampleRate = bufferData.sampleRate; // サンプルレート（通常44.1kHz）
    const interval = 0.1; // 100ms
    const maxCheckSamples = Math.round(sampleRate * interval); // 100ms分のサンプル数

    let silenceStart = null;
    let silences = [];

    for (let i = 0; i < channelData.length; i += maxCheckSamples) {
      let sum = 0;
      let count = 0;
      for (let j = i; j < i + maxCheckSamples && j < channelData.length; j++) {
        sum += Math.abs(channelData[j]); // 絶対値を取得
        count++;
      }
      const average = sum / count;

      if (average < threshold) {
        if (silenceStart === null) silenceStart = i;
      } else {
        if (silenceStart !== null) {
          silences.push({
            start: silenceStart / sampleRate,
            end: i / sampleRate,
          });
          silenceStart = null;
        }
      }
    }

    // 最後の部分が静寂で終わっている場合
    if (silenceStart !== null) {
      silences.push({
        start: silenceStart / sampleRate,
        end: channelData.length / sampleRate,
      });
    }

    return silences;
  }
  */
}

//Mouth Movement Class
class MouthMovement {
  constructor(model) {
    this.INTERVAL_FPS = 7;
    this.MOUTH_ACTION_INTERVAL_FPS = 60;

    this.status = 'stop'; //stop or playing
    this.model = model;
    this.interval = null;
    this.mouthActionInterval = null;
    this.mouthTargetValue = 0;
    this.mouthCurrentValue = 0;
    this.mouthDirection = 'up';
    this.mouthTargetValue2 = 0;
    this.mouthCurrentValue2 = 0;
    this.mouthDirection2 = 'up';
  }

  setStatus(status) {
    this.status = status;
  }

  startPlaying() {
    if (this.model == null) return;
    // this.model.internalModel.motionManager.groups.idle = 'Acting';
    this.status = 'playing';
    this.startMouthMovement();
  }

  stopPlaying() {
    if (this.model == null) return;
    //this.model.internalModel.motionManager.groups.idle = 'Idle';
    clearInterval(this.interval);
    this.backToZeroMouth();
  }

  startMouthMovement() {
    this.interval = setInterval(() => {
      if (this.status == 'stop') {
        this.backToZeroMouth();
      } else {
        var random = Math.random() * 1.3; // 0.0 ~ 1.3 -> increase the possibility to 1
        if (random > 1) random = 1;
        var plusOrMinus = Math.random() < 0.5 ? -1 : 1;

        if (random !== this.mouthTargetValue) {
          this.mouthTargetValue = random;
          this.mouthTargetValue2 = random * plusOrMinus;
          this.moveMouth();
        }
      }
    }, 1000 / this.INTERVAL_FPS);
  }

  moveMouth() {
    if (this.mouthActionInterval !== null) {
      clearInterval(this.mouthActionInterval);
      this.mouthActionInterval = null;
    }

    if (this.mouthTargetValue >= this.mouthCurrentValue) {
      this.mouthDirection = 'up';
    } else {
      this.mouthDirection = 'down';
    }

    if (this.mouthTargetValue2 >= this.mouthCurrentValue2) {
      this.mouthDirection2 = 'up';
    } else {
      this.mouthDirection2 = 'down';
    }

    this.mouthActionInterval = setInterval(() => {
      let addValue = 0.1;

      if (this.mouthDirection === 'up') {
        this.mouthCurrentValue += addValue;
        if (this.mouthCurrentValue >= this.mouthTargetValue) {
          this.mouthCurrentValue = this.mouthTargetValue;
        }
      } else {
        this.mouthCurrentValue -= addValue;
        if (this.mouthCurrentValue <= this.mouthTargetValue) {
          this.mouthCurrentValue = this.mouthTargetValue;
        }
      }

      if (this.mouthDirection2 === 'up') {
        this.mouthCurrentValue2 += addValue;
        if (this.mouthCurrentValue2 >= this.mouthTargetValue2) {
          this.mouthCurrentValue2 = this.mouthTargetValue2;
        }
      } else {
        this.mouthCurrentValue2 -= addValue;
        if (this.mouthCurrentValue2 <= this.mouthTargetValue2) {
          this.mouthCurrentValue2 = this.mouthTargetValue2;
        }
      }

      this.updateMouthValue();

      if (this.mouthCurrentValue === this.mouthTargetValue) {
        clearInterval(this.mouthActionInterval);
        this.mouthActionInterval = null;
      }
    }, 1000 / this.MOUTH_ACTION_INTERVAL_FPS);
  }

  backToZeroMouth() {
    if (this.mouthCurrentValue != 0 || this.mouthCurrentValue2 != 0) {
      this.mouthCurrentValue = 0;
      this.mouthCurrentValue2 = 0;
      //this.moveMouth();
      this.updateMouthValue();
    }
  }

  updateMouthValue() {
    const internalModel = this.model.internalModel;
    const coreModel = internalModel.coreModel;

    coreModel.setParameterValueById('ParamMouthOpenY', this.mouthCurrentValue);
    coreModel.setParameterValueById('ParamMouthForm', this.mouthCurrentValue2);
  }
}
